import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';
import Config from '../models/Config';

export default (): Config => useContext(ConfigContext) as Config;
